import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import RichTextEditor from "../../../../Components/Editor/RichTextEditor";
import AddFormModal from "../../../../Components/Modal/supplier_app/AddFormModal";

//Redux
import { useSelector, useDispatch } from "react-redux";

//Serivce
import ItemService from "../../../../services/supplier_appCommonService";
import CustomerItemService from "../../../../services/customer_v2_appCommonService";

//Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import DataTable from "react-data-table-component";
import CreateRFQSuppliersModalV2 from "./CreateRFQSuppliersModalV2";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import {
  checkTimeDifference,
  formatDate,
  getTodayDate,
  isValidNumber,
  validateContactNumber,
  validateRequired,
} from "../../../../common/Validations";
import SuccessRegisterModal from "../../../../Components/SuccessRegisterModal";
import CustomerConstants from "../../../../common/CustomerConstants";
import { customerGetRfqQuotation } from "../../../../redux/feature/customer_app/customerSlice";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";

const CreateRFQV2 = () => {
  const dispatch = useDispatch();

  localStorage.setItem("menu", "Sourcing");
  localStorage.setItem("submenu", "Request for Quotation");
  let userData = useSelector((state) => state?.user?.data);

  let indentData = useSelector(
    (state) => state?.customer?.indent?.selectedIndentRows
  );
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible6, setCardVisible6] = useState(true);
  const [isCardVisible7, setCardVisible7] = useState(true);
  const [getCompanyCode, setCompanyCode] = useState([]);
  const [isCardVisible10, setCardVisible10] = useState(true);
  const [disabled, setDisabled] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");
  const [editorContent, setEditorContent] = useState("");
  const [getRFxType, setRFxType] = useState([]);
  const [getRFxProductType, setRFxProductType] = useState([]);

  const [getShowFailureModal, setShowFailureRFQ] = useState(false);

  const [getLineItemData, setLineItemData] = useState([]);
  const [getCreateDynamicformModelShow, setCreateDynamicformModelShow] =
    useState(false);
  const [formInputs, setFormInputs] = useState({
    rfxType: "",
    productType: "",
    rfxValue: "",
    rfxHeaderStatus: "Publish",
    rfxCurrency: "",
    rfxTechFocalPersonId: "",
    technicalApprovalType: "",
    plant: "",
    rfqType: "Indent",
    buyerResponsible: userData?.firstName,
    companyAddress: "", //i did'nt get in json
    rfxVersion: "V0",
    buyerEmail: userData?.email,
    initiator: userData?.userId,
    buyerConact: userData?.contactNumber,

    createdOn: getTodayDate(), //i did'nt get in json

    deliveryAddressCodeDesc: "",
    rfxTitle: "",
    companyCode: "",
    openingDate: "",
    openingTime: "",
    closingDate: "",
    closingTime: "",
    rfxDescription: "",
    typeOfPurchase: "",
    otherCurrencies: "",
    headerIncoTerms: "",
    incoTermsLocation: "",
    procurementStrategies: "",
    openingDateTime: "",
    closingDateTime: "",
    totalHour: "",
  });

  const [getOpenCloseInput, setOpenCloseInput] = useState({
    openingDate: "",
    openingTime: "",
    closingDate: "",
    closingTime: "",
    totalHour: "",
    status: false,
    msg: "",
  });

  const [validation, setValidation] = useState({
    rfxValue: "",
    buyerConact: "",
  });
  const modalData = {
    title: "RFQ Creation",
    successMsg: "",
  };

  const message = {
    VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
    VALID_MAIL_ID: "Please enter a valid email address.",
    VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
    VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
    VALID_ALTERNATE_CONTACT_NUMBER:
      "Please enter a valid alternate contact number.",
    VALID_PURPOSE_JUSTIFICATION:
      "Please ensure the justification is under 500 characters.",
    VALID_POSTAL_CODE:
      "Enter a 6-character postal code with uppercase letters and numbers only",
    VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
    VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
    EXIStS_MAIL_ID: "Email already exists",
    EXIStS_CONTACT_NUMBER: "Contact Number already exists",
    EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
    EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
    FILL_REQUIRED_FIELD: "Please fill the required field",
    ALTERNATE_MAIL_ID: "Email ID is same",
    ALTERNATE_CONTACT_NUMBER: "Contact number is same",
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  const toggleCardVisibility6 = () => {
    setCardVisible6(!isCardVisible6);
  };
  const toggleCardVisibility7 = () => {
    setCardVisible7(!isCardVisible7);
  };
  const toggleCardVisibility10 = () => {
    setCardVisible10(!isCardVisible10);
  };

  const onInputChange = ({ target: { name, value } }) => {
    let error = "";

    if (name === "rfxValue" && !validateRequired(value)) {
      error = message.FILL_REQUIRED_FIELD;
    }

    if (name === "buyerConact" && !validateContactNumber(value)) {
      error = message.VALID_CONTACT_NUMBER;
    }

    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));

    setValidation((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  // This is for Text Editor
  const handleEditorChange = (content) => {
    setEditorContent(content);
  };

  useEffect(() => {
    if (indentData?.length > 0) {
      let indexCounter = 0;
      const allItemsWithDocNum = indentData.flatMap((indent) =>
        (indent.items || []).map((item, index) => ({
          ...item,
          documentNumber: indent.documentNumber,
          index: ++indexCounter, // Assign a unique index to each item
          local_id: indexCounter, // Set the local_id to the index value (or any custom logic)
        }))
      );
      setLineItemData(allItemsWithDocNum);
    }
  }, [indentData]);

  const suppliersColumns = [
    {
      name: "Supplier ID",
      selector: (row) => row.userId || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btnInfo"
        // onClick={() => detailedPage(row.AssociateNumber)}
        >
          {row.userId || "-"}{" "}
        </button>
      ),
      width: "120px",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => (
        <>
          <TableStatusField status={row.status} />
        </>
      ),
      width: "170px",
    },

    {
      name: "Supplier",
      selector: (row) => row.organisationName,
      sortable: true,
      width: "180px",
    },
    {
      name: "Contact Person",
      selector: (row) => row.contactfirstName || "--",
      sortable: true,
      width: "150px",
    },

    {
      name: "Contact Number",
      selector: (row) => row.contactNumber || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "EMail",
      selector: (row) => row.email,
      sortable: true,
      width: "250px",
    },
    {
      name: "Category",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
          // onClick={() => categoryItemShowModal(row.vendorCategory)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.vendorCategory?.length || 0}{" "}
          </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Created Date",
      cell: (row) => (
        <div>
          <p className="m-0 p-0">{formatDate(row?.createdAt)} </p>
        </div>
      ),
      width: "160px",
    },
  ];

  const [getModalInfo, setModalInfo] = useState(modalData);
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const onSuccessfullyRegistered = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };
  // const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [getErrorFields, setErrorFields] = useState([]);
  const [getFailureModal] = useState(failureModalData);

  const hideFailureModal = () => {
    setShowFailureRFQ(false);
  };

  // Get Dropdown data select
  useEffect(() => {
    if (getDropdownData?.name) {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  //Load Master Data
  const getMasterDataFunc = async () => {
    let obj2 = {
      codeType: "RFxType",
    };
    await ItemService.getMasterData(obj2).then((item) => {
      if (item?.status === 200) {
        setRFxType(item?.data);
      } else {
        setRFxType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj3 = {
      codeType: "RFxProductType",
    };
    await ItemService.getMasterData(obj3).then((item) => {
      if (item?.status === 200) {
        setRFxProductType(item?.data);
      } else {
        setRFxProductType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj1 = {
      codeType: "companyCode",
    };
    await ItemService.getMasterData(obj1).then((item) => {
      // console.log(">> item! title", item);
      if (item?.status === 200) {
        setCompanyCode(item?.data);
      } else {
        setCompanyCode([]);
        console.log(">> Error: Loading Company Code");
      }
    });
  };

  useEffect(() => {
    getMasterDataFunc();

    // eslint-disable-next-line no-unused-vars
  }, []);

  /* submit button */
  const handleCreateRFQ = async () => {
    let requiredFields = [];

    if (formInputs.rfxValue === "") {
      requiredFields.push("* Please enter the Estimated RFQ Value.");
      setErrorFields(requiredFields);
      setShowFailureRFQ(true);
      return;
    }
    if (getSupplierData.length === 0) {
      requiredFields.push("* Add atleast one supplier.");
      setErrorFields(requiredFields);
      setShowFailureRFQ(true);
      return;
    }

    if (!validateRequired(formInputs.buyerConact)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureRFQ(true);
      setValidation((prev) => ({
        ...prev,
        buyerConact: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateContactNumber(formInputs.buyerConact)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureRFQ(true);
      setValidation((prev) => ({
        ...prev,
        buyerConact: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    formInputs.items = getLineItemData;
    // rfqCreation === "PR" ? getLineItemData : getPRLineItemsData;
    formInputs.supplierList = getSupplierData;
    formInputs.instructions = editorContent;

    // open and close date
    formInputs.openingDateTime =
      getOpenCloseInput.openingDate + " " + getOpenCloseInput.openingTime;
    formInputs.closingDateTime =
      getOpenCloseInput.closingDate + " " + getOpenCloseInput.closingTime;
    formInputs.totalHour = getOpenCloseInput.totalHour;

    formInputs.openingDate = getOpenCloseInput.openingDate;
    formInputs.openingTime = getOpenCloseInput.openingTime;
    formInputs.closingDate = getOpenCloseInput.closingDate;
    formInputs.closingTime = getOpenCloseInput.closingTime;
    const cleanObject = (input) => {
      if (Array.isArray(input)) {
        return input.map(cleanObject); // recursively clean array elements
      } else if (typeof input === "object" && input !== null) {
        return Object.fromEntries(
          Object.entries(input)
            .filter(
              ([key, value]) => key !== "undefined" && value !== undefined
            )
            .map(([key, value]) => [key, cleanObject(value)])
        );
      }
      return input;
    };
    let cleanedFormInputs = cleanObject(formInputs);
    let obj = {
      data: cleanedFormInputs,
    };
    setDisabled(false);
    await CustomerItemService.addRfx(obj).then((item) => {
      if (item?.status === 200) {
        modalData.successMsg = item?.message;
        setModalInfo(modalData);
        onSuccessfullyRegistered();
        dispatch(customerGetRfqQuotation({}));
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setDisabled(true);
  };

  /* suppplierModalShow */
  const [getSupplierModal, setSupplierModal] = useState(false);
  const suppplierModalShow = () => {
    setSupplierModal(true);
  };
  const supplerMoadHide = () => {
    setSupplierModal(false);
  };

  /* selectedSupplierIds */
  const [selectedSuppliers, setSelectedSuppliers] = useState([]);
  const [getSupplierData, setSupplierData] = useState([]);

  const handleSelectedRows = (selectedRows) => {
    setSelectedSuppliers(selectedRows);
  };

  const handlePassDataToParent = (data) => {
    // You can now use this data in the parent component

    setSupplierData((prevData) => {
      // Combine previous data and filter out duplicates based on id
      const updatedData = [
        ...prevData,
        ...data.filter(
          (newObj) =>
            !prevData.some(
              (existingObj) =>
                existingObj.AssociateNumber === newObj.AssociateNumber
            )
        ),
      ];
      return updatedData;
    });

    setSupplierData((prevData) => {
      const updatedData = [...prevData];

      data.forEach((newObj) => {
        const index = updatedData.findIndex(
          (existingObj) => existingObj.userId === newObj.userId
        );

        if (index !== -1) {
          // If found, update the existing object
          updatedData[index] = newObj;
        } else {
          // If not found, add as a new entry
          updatedData.push(newObj);
        }
      });

      return updatedData;
    });
  };

  /*  PRLineItem*/
  let PRLineItemInitialCol = [
    {
      name: "Document Item Nr",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Document Nr",
      selector: (row) => row.documentNumber,
      cell: (row) => (
        <>
          <span class="bg-table-status bg-table-new-status">
            {row.documentNumber}
          </span>
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Item Text",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.itemTextData)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
    },
    {
      name: "Material/Service ",
      selector: (row) => row.materialCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialCode"
          placeholder=""
          value={row.materialCode || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Description",
      selector: (row) => row.materialDescription || "--",
      cell: (row) => (
        <TextAreaField
          className="inputBox mt-1"
          name="materialDescription"
          placeholder=""
          value={row.materialDescription || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Material Group ",
      selector: (row) => row.materialGroup || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialGroup"
          placeholder=""
          value={row.materialGroup || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Quantity ",
      selector: (row) => row.indentQuantity || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="indentQuantity"
          placeholder=""
          value={row.indentQuantity || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "UOM ",
      selector: (row) => row.orderUnitOfMeasure || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderUnitOfMeasure"
          placeholder=""
          value={row.orderUnitOfMeasure || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    {
      name: "Location",
      selector: (row) => row.storageLocn || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="storageLocn"
          placeholder=""
          value={row.storageLocn || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
  ];
  let PRLineItemInitialData = [
    {
      local_id: 1,
      rfxNr: 1,
      itemTextData: [],
      statusItem: "In Release",
      currency: "Rupee",
      currencyCode: "INR",
      taxCode: 0,
      taxAmount: 0,
    },
  ];

  // PO items columns Details
  const lineItemColInfo = [
    {
      name: "Code",
      cell: (row) => <span>{row.documentId} </span>,
      width: "200px",
    },
    {
      name: "Text",
      cell: (row) => <span>{row.documentText} </span>,
      width: "250px",
    },
  ];

  // Show Item level data
  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Item Text Details");
    setItemLevelModalShow(true);
  };
  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };

  const [, /*getPRLineItemsData*/ setPRLineItemsData] = useState(
    PRLineItemInitialData
  );

  const handleInputChange = (local_id, event, type, vat) => {
    const { name, value } = event.target;
    if (type === "Number" && vat === undefined) {
      if (isValidNumber(value)) {
        setPRLineItemsData((prevRows) =>
          prevRows.map((row) => {
            return row.local_id === local_id
              ? {
                ...row,
                [name]: value,
                netValue:
                  name === "indentQuantity"
                    ? row.orderPriceUnit * value
                    : row.indentQuantity * value,
                taxAmount:
                  (Number(row.taxCode) / 100) *
                  (name === "indentQuantity"
                    ? row.orderPriceUnit * value
                    : row.indentQuantity * value),
              }
              : row;
          })
        );
      }
    } else if (type === "Number" && vat === "VAT") {
      if (isValidNumber(value)) {
        setPRLineItemsData((prevRows) =>
          prevRows.map((row) =>
            row.local_id === local_id
              ? {
                ...row,
                [name]: value,
                taxAmount:
                  name === "taxCode"
                    ? (Number(value) / 100) *
                    (Number(row.indentQuantity || 0) *
                      Number(row.orderPriceUnit || 0))
                    : 0,
              }
              : row
          )
        );
      }
    } else {
      setPRLineItemsData((prevRows) =>
        prevRows.map((row) =>
          row.local_id === local_id ? { ...row, [name]: value } : row
        )
      );
    }
    // getTotalCount()
  };

  const hideModalStatus = () => {
    setCreateDynamicformModelShow(false);
  };

  const onInputChangeopeningDate = ({ target: { name, value } }) => {
    setOpenCloseInput((getOpenCloseInput) => ({
      ...getOpenCloseInput,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (
      getOpenCloseInput.openingDate !== "" ||
      getOpenCloseInput.openingTime !== "" ||
      getOpenCloseInput.closingDate !== "" ||
      getOpenCloseInput.closingTime !== ""
    ) {
      let openDate =
        getOpenCloseInput.openingDate + " " + getOpenCloseInput.openingTime;
      let closeDate =
        getOpenCloseInput.closingDate + " " + getOpenCloseInput.closingTime;
      let res = checkTimeDifference(openDate, closeDate);

      getOpenCloseInput.status = res.status;
      getOpenCloseInput.msg = res.msg + " '(Opening and Closing Fields)' !!";

      if (getOpenCloseInput.closingDate !== "") {
        if (res.status) {
          getOpenCloseInput.totalHour = res.totalHours;
        } else {
          toast.error(res.msg, {
            duration: 4000,
            position: "top-right",
          });
        }
      }
    }
  }, [getOpenCloseInput]);

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Create RFQ </h2>
            <p className="subText">Fill RFQ Details</p>
            <hr />
            {/* 01 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">RT</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">RFQ Type</span>
                      <span className="subHeaderTitle">Basic Information</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="RFQ Type"
                          placeholder=""
                          data={getRFxType}
                          id="rfxType"
                          iconClassName="dropdownIcon"
                          name="rfxType"
                          code="rfxTypeCode"
                          description="rfxTypeDesc"
                          setValue={formInputs.rfxTypeDesc || ""}
                          getvalue={setDropdownData}
                        // className="dropdownOption"
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Product Type"
                          placeholder=""
                          data={getRFxProductType}
                          id="productType"
                          iconClassName="dropdownIcon"
                          name="productType"
                          code="productTypeCode"
                          description="productTypeDesc"
                          setValue={formInputs.productTypeDesc || ""}
                          getvalue={setDropdownData}
                        // className="dropdownOption"
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Estimated RFQ Value "
                          id="rfxValue"
                          name="rfxValue"
                          placeholder=""
                          // type="checkbox"
                          value={formInputs.rfxValue || ""}
                          error={validation.rfxValue || ""}
                          onChange={onInputChange}
                          required={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* 02 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">RH</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">RFQ Header</span>
                      <span className="subHeaderTitle">Header Description</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${isCardVisible2 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Buyer Responsible"
                          name="initiator"
                          placeholder=""
                          value={formInputs.buyerResponsible || ""}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Create / Initiator"
                          name="initiator"
                          placeholder=""
                          value={formInputs.initiator || ""}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Company Name"
                          placeholder=""
                          data={getCompanyCode}
                          id="companyCode"
                          iconClassName="dropdownIcon"
                          name="companyCode"
                          code="companyCode"
                          description="companyCodeDesc"
                          setValue={formInputs.companyCode || ""}
                          getvalue={setDropdownData}
                          required={true}
                        // error={validation.companyCode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Buyer Email"
                          name="buyerEmail"
                          id="buyerEmail"
                          placeholder=""
                          value={formInputs.buyerEmail || ""}
                          // onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Buyer Contact"
                          name="buyerConact"
                          id="buyerConact"
                          placeholder=""
                          value={formInputs.buyerConact || ""}
                          error={validation?.buyerConact || ""}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Created On"
                          name="createdOn"
                          id="createdOn"
                          type="date"
                          placeholder=""
                          value={formInputs.createdOn || ""}
                          onChange={onInputChange}
                        // disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          className="inputBox"
                          label="Billing Address"
                          name="billingAddress"
                          id="billingAddress"
                          placeholder=""
                          value={formInputs.billingAddress || ""}
                          onChange={onInputChange}
                        // disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          className="inputBox"
                          label="Delivery Address"
                          name="deliveryAddressCodeDesc"
                          id="deliveryAddressCodeDesc"
                          placeholder=""
                          value={formInputs.deliveryAddressCodeDesc || ""}
                          onChange={onInputChange}
                        // disabled={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* header info 03*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">HI</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">Header Info</span>
                      <span className="subHeaderTitle">Header Information</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${isCardVisible3 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Title"
                          name="rfxTitle"
                          id="rfxTitle"
                          placeholder=""
                          value={formInputs.rfxTitle || ""}
                          onChange={onInputChange}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Opening Date"
                          name="openingDate"
                          id="openingDate"
                          type="date"
                          placeholder=""
                          value={getOpenCloseInput.openingDate || ""}
                          onChange={onInputChangeopeningDate}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Opening Time"
                          name="openingTime"
                          id="openingTime"
                          type="time"
                          placeholder=""
                          value={getOpenCloseInput.openingTime || ""}
                          onChange={onInputChangeopeningDate}
                          required={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Description"
                          name="rfxDescription"
                          id="rfxDescription"
                          placeholder=""
                          value={formInputs.rfxDescription || ""}
                          onChange={onInputChange}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Closing Date"
                          name="closingDate"
                          id="closingDate"
                          type="date"
                          placeholder=""
                          value={getOpenCloseInput.closingDate || ""}
                          onChange={onInputChangeopeningDate}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Closing Time"
                          name="closingTime"
                          id="closingTime"
                          type="time"
                          placeholder=""
                          value={getOpenCloseInput.closingTime || ""}
                          onChange={onInputChangeopeningDate}
                          required={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Instructions 10*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible10
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility10}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">I</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">Instructions</span>
                      <span className="subHeaderTitle">
                        Instructions Section
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${isCardVisible10 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="p-4">
                      <Col xs={12} md={12} lg={12}>
                        <RichTextEditor
                          value={editorContent}
                          onChange={handleEditorChange}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Line Items 06*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible6
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility6}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">LI</span>
                    </Col>
                    <Col xs={8} md={4} lg={4}>
                      <span className="headerTitle">Line Items</span>
                      <span className="subHeaderTitle">
                        Material/ Service Details
                      </span>
                    </Col>

                    <Col
                      xs={12}
                      md={6}
                      lg={6}
                      className="headerButtonAlign"
                    ></Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${isCardVisible6 ? "visible" : ""
                    }`}
                // aria-labelledby="headingOne"
                // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          // title=""
                          columns={PRLineItemInitialCol}
                          data={getLineItemData}
                          // data={
                          //   formInputs?.rfqCreation === "PR"
                          //     ? getLineItemData
                          //     : getPRLineItemsData
                          // }
                          // columns={lineItemsColumns}
                          // data={lineItemsData}
                          // progressPending={loading}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          // pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Suppliers 07*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible7
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility7}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">S</span>
                    </Col>
                    <Col xs={8} md={4} lg={4}>
                      <span className="headerTitle">Suppliers</span>
                      <span className="subHeaderTitle">Supplier Details</span>
                    </Col>

                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      <Col xs={4} md={2} lg={2} className="">
                        <button
                          className="btnTable"
                          onClick={suppplierModalShow}
                        >
                          Add Supplier
                        </button>
                      </Col>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${isCardVisible7 ? "visible" : ""
                    }`}
                // aria-labelledby="headingOne"
                // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          // title=""
                          columns={suppliersColumns}
                          data={getSupplierData}
                          // progressPending={loading}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          // pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <Row className="rowDirection mb-4 pb-2">
        <Col
          xs={2}
          md={2}
          lg={2}
          className="mb-2"
        >
          <button
            disabled={disabled}
            className="btnTable"
            onClick={handleCreateRFQ}
          >
            Create RFQ
          </button>
        </Col>
      </Row>

      <CreateRFQSuppliersModalV2
        show={getSupplierModal}
        onHide={supplerMoadHide}
        selectedSuppliers={selectedSuppliers}
        onSelectedRows={handleSelectedRows}
        passDataToParent={handlePassDataToParent}
      />
      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        modaldata={getModalInfo}
        aftersuccess={CustomerConstants.CUSTOMER_V2_RFQ_LIST}
      />

      <AddFormModal
        show={getCreateDynamicformModelShow}
        onHide={() => hideModalStatus()}
      // modeldata={getFormModalData}
      />

      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />

      {/* Item Text  */}
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
    </main>
  );
};

export default CreateRFQV2;
